import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ForkLiftJobDTO } from '.';

export class GetAllForkLiftJobsResponseModel extends GlobalResponseObject {
    data?: ForkLiftJobDTO[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: ForkLiftJobDTO[]){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}